import { LeftNav } from './LeftNav';
import { LeftNavHeader } from './LeftNavHeader';
import { LeftNavLink } from './LeftNavLink';

LeftNav.Header = LeftNavHeader;
LeftNav.Link = LeftNavLink;

export { LeftNav };
